module.exports = __webpack_public_path__ + "img/arrow-circle-left.d034f745.svg";